module.exports = {};



//////////////////
// WEBPACK FOOTER
// /Users/philipeskins/Desktop/Epicodus/monopoly/node_modules/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = polyfills